import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import Layout from "./Components/Layout/Layout";
import Home from "./Components/Home";
import StationWiseData from "./Components/StationWiseData";
import Details from "./Components/Details";

function App() {
  return (
    <div className="App overflow-hidden">
      <BrowserRouter>
        <Routes>
           <Route
            path="/"
            element={
              <Layout>
                <Home />{" "}
              </Layout>
            }
          />
          <Route
            path="/Home"
            element={
              <Layout>
                <Home />{" "}
              </Layout>
            }
          />
         
           
          <Route
            path="/Stations"
            element={
              <Layout>
                <StationWiseData />
              </Layout>
            }
          />   
          <Route
            path="/Details"
            element={
              <Layout>
                <Details />
              </Layout>
            }
          />            
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
